import { $elParent } from 'src/scripts/utils/utils'
import { ModalComponent } from '../../components/modal/modal'
import { LookbookComponent } from './index'

const LOOKBOOK_SELECTOR = 'lookbook-component'

export class LookbookModal extends ModalComponent {
  async show(): Promise<void> {
    await super.show()

    const lookbook: LookbookComponent = $elParent(LOOKBOOK_SELECTOR, this)

    lookbook?.showBlockById(lookbook.selectedPinId)
  }
}
